import PersianSupportNumericTextField from 'Global/Components/UnEditableComponents/PersianSupportNumericTextField/PersianSupportNumericTextField';
import PersianSupportTextField from 'Global/Components/UnEditableComponents/PersianSupportTextField/PersianSupportTextField';
import React from 'react';
import { Stack } from '@mui/material';
import SingularDatePicker from 'Global/Components/UnEditableComponents/SingularDatePicker/SingularDatePicker';
const AdditionalSearchField = (props) => {
  const {
    setFilter,
    label_patient_number_request,
    label_patient_name_patient,
    label_patient_family_patient,
    label_file_number,
    lab_patient_patient_id_textbox,
  } = props;

  return (
    <React.Fragment>
      <Stack direction="row" gap="1em">
        <PersianSupportTextField
          label={lab_patient_patient_id_textbox}
          onChange={(val) => {
            setFilter((prev) => ({
              ...prev,
              idPatient: val.length === 0 ? 0 : val,
            }));
          }}
        />

        {/* <SingularDatePicker
          label={label_patient_number_request}
          onChange={(val) => {
            setFilter((prev) => ({
              ...prev,
              ShomareDarkhast: val.split('/').join('-'),
            }));
          }}
        /> */}
        {/* <PersianSupportNumericTextField
          label={label_patient_number_request}
          onChange={(val) => {
            // setFilter((prev) => ({
            //   ...prev,
            //   ShomareDarkhast: val,
            // }));
          }}
          isOctalAllowed={true}
        /> */}
        {/* <PersianSupportNumericTextField
          label={label_patient_number_request}
          onChange={(val) => {
            // setFilter((prev) => ({
            //   ...prev,
            //   ShomareDarkhast: val,
            // }));
          }}
          isOctalAllowed={true}
        /> */}
        <PersianSupportNumericTextField
          label={label_file_number}
          onChange={(val) => {
            setFilter((prev) => ({
              ...prev,
              ShomareParvande: val,
            }));
          }}
          isOctalAllowed={true}
        />
      </Stack>

      <Stack direction="row" gap=".5em">
        <PersianSupportTextField
          label={label_patient_family_patient}
          onChange={(val) => {
            setFilter((prev) => ({
              ...prev,
              familyPatient: val,
            }));
          }}
        />
        {/* <PersianSupportTextField
          label={label_patient_family_patient}
          onChange={(val) => {
            setFilter((prev) => ({
              ...prev,
              familyPatient: val,
            }));
          }}
        /> */}
      </Stack>
    </React.Fragment>
  );
};

export default AdditionalSearchField;
